module.exports = __webpack_public_path__ + "img/3.9d4c1ebe.jpg";